import axiosInstance from "../../../shared/api/axiosInstance";
import { configReq } from "../../../shared/lib/functions";
import { readConfiguration } from "./payments";

const endpoint = "admin/v2/PaymentGateways/zarinpal/configuration";
export async function getZarinpalSettings(token, signal) {
  return readConfiguration((await axiosInstance.get(endpoint, { ...configReq(token), signal, timeout: 15000 })).data);
}
export async function saveZarinpalSettings(token, value) {
  const payload = { version: value.version, enabled: value.enabled, testMode: value.testMode,
    notificationUrl: value.notificationUrl.trim(), redirectUrl: value.redirectUrl.trim(), cancelUrl: "",
    clearTestKey: Boolean(value.clearTestKey), clearLiveKey: Boolean(value.clearLiveKey) };
  if (value.testApiKey.trim()) payload.testApiKey = value.testApiKey.trim();
  if (value.liveApiKey.trim()) payload.liveApiKey = value.liveApiKey.trim();
  return readConfiguration((await axiosInstance.put(endpoint, payload, { ...configReq(token), timeout: 15000 })).data);
}
export async function revealZarinpalKey(token, environment) {
  if (!["test", "live"].includes(environment)) throw new Error("invalid key environment");
  const response = await axiosInstance.post(`${endpoint}/keys/${environment}`, {}, { ...configReq(token), timeout: 15000 });
  const key = response.data.apiKey ?? response.data.ApiKey;
  if (typeof key !== "string" || key.length > 36) throw new Error("invalid merchant response");
  return key;
}
